import { CompanyReportFormIds } from 'app/area/company-reports-administration/form/constants';
import { deepEquals } from 'app/infrastructure/js';
import { ComplexValue } from 'app/types-shared';
import { CompanyReportItem, CompareFieldsData, SavedReportCompanyReport } from '../types-store';

const compareValues = (values: ComplexValue<number>[], originalValues: ComplexValue<number>[]): boolean => {
  const current = values || [];
  const original = originalValues || [];

  if (current.length !== original.length) {
    return true;
  }

  return current.some(
    value => !original.some(
      originalValue => value.value === originalValue.value
    ));
};

export const compareFields = <T>(data: CompareFieldsData<T>) => {
  const { fields, values, originalValues } = data;

  const newValues = values?.filter(value =>
    fields
      .map(field => value[field])
      .some(item => !!item) && value);

  return !deepEquals(newValues, originalValues);
};

export const hasChanges = (item?: CompanyReportItem, original?: CompanyReportItem): boolean => {

  const compare = item?.id !== original?.id ||
    item?.disabled?.getTime() !== original?.disabled?.getTime() ||
    item?.sequence !== original?.sequence ||

    item?.defaultTemplate !== original?.defaultTemplate ||

    compareValues(item?.subset, original?.subset) ||

    item?.usePredefDate !== original?.usePredefDate ||
    item?.predefinedDate?.value !== original?.predefinedDate?.value ||

    item?.emailReport !== original?.emailReport ||
    item?.textId !== original?.textId ||
    !deepEquals(item?.textSet, original?.textSet) ||
    item?.textDescription !== original?.textDescription ||

    !deepEquals(item?.excelMapping, original?.excelMapping) ||

    compareFields({
      fields: [
        CompanyReportFormIds.textSet,
        CompanyReportFormIds.textId,
        CompanyReportFormIds.textDescription,
        CompanyReportFormIds.cell,
        CompanyReportFormIds.range
      ],
      values: item?.texts,
      originalValues: original?.texts
    }) ||
    compareFields({
      fields: [
        CompanyReportFormIds.metadataType,
        CompanyReportFormIds.cell,
        CompanyReportFormIds.range
      ],
      values: item?.metadata,
      originalValues: original?.metadata
    });

  if (compare) {
    return true;
  }

  const language = ((item ?? {}).language ?? [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);
  const originalLanguage = ((original || {}).language || [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);

  if (language.length !== originalLanguage.length) {
    return true;
  }

  if (language.some(
    languageItem => !originalLanguage.some(
      originalLanguageItem => (languageItem.value ?? '') === (originalLanguageItem.value ?? '') &&
        (languageItem.description ?? '') === (originalLanguageItem.description ?? ''))
  )) {
    return true;
  }

  return false;
};

const detailsValueHasChanges = (
  item?: string,
  original?: string
): boolean =>
  (item?.trim() ?? '') !== (original?.trim() ?? '');

const savedReportHasChanges = (
  savedReport: SavedReportCompanyReport,
  original: SavedReportCompanyReport
): boolean =>
  detailsValueHasChanges(savedReport.reportIdCell, original.reportIdCell) ||
  detailsValueHasChanges(savedReport.reportIdRange, original.reportIdRange) ||
  detailsValueHasChanges(savedReport.reportNameCell, original.reportNameCell) ||
  detailsValueHasChanges(savedReport.reportNameRange, original.reportNameRange) ||
  detailsValueHasChanges(savedReport.reportResultCell, original.reportResultCell) ||
  detailsValueHasChanges(savedReport.reportResultRange, original.reportResultRange);

export const savedReportsHaveChanges = (
  savedReports: SavedReportCompanyReport[] = [],
  original: SavedReportCompanyReport[] = []
): boolean => {

  if (savedReports.length !== original.length) {
    return true;
  }

  for (const savedReport of savedReports) {
    const originalSavedReport = original.find(report => savedReport.code?.value === report.code?.value);

    if (!originalSavedReport || savedReportHasChanges(savedReport, originalSavedReport)) {
      return true;
    }
  }

  return false;
};
